import { render, staticRenderFns } from "./ArchiveDownload.vue?vue&type=template&id=99946eba&scoped=true&"
import script from "./ArchiveDownload.vue?vue&type=script&lang=js&"
export * from "./ArchiveDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99946eba",
  null
  
)

export default component.exports